import { QueryClient } from '@tanstack/react-query'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 15_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
})

export const qk = {
  conversations: (params: Record<string, string | undefined>) => ['conversations', params] as const,
  conversation: (id: string) => ['conversation', id] as const,
  reminders: (id: string) => ['reminders', id] as const,
  customer: (id: string) => ['customer', id] as const,
  customerOrders: (id: string) => ['customerOrders', id] as const,
  products: (q?: string) => ['products', q ?? ''] as const,
  stores: () => ['stores'] as const,
  channelAccounts: () => ['channelAccounts'] as const,
  agents: () => ['agents'] as const,
  quickReplies: () => ['quickReplies'] as const,
  users: () => ['users'] as const,
  integrations: () => ['integrations'] as const,
  whatsappConfig: () => ['whatsappConfig'] as const,
  whatsappQr: (id: string) => ['whatsappQr', id] as const,
  storedSuggestion: (id: string) => ['storedSuggestion', id] as const,
  conversationProduct: (id: string) => ['conversationProduct', id] as const,
  conversationHistory: (id: string) => ['conversationHistory', id] as const,
  ticketsForCustomer: (customerId: string) => ['tickets', 'customer', customerId] as const,
  allTickets: (filter: string) => ['tickets', 'all', filter] as const,
  log: (params: Record<string, unknown>) => ['log', params] as const,
  autoReply: () => ['autoReply'] as const,
}
